import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

import { LogLevels, type Logger, createLogger } from '@backmarket/front-logger'

import { useAttributes } from './composables/useAttributes'
import { useTransports } from './composables/useTransports'

type Injections = {
  logger: Logger
}

export function createLoggerPlugin() {
  const config = useRuntimeConfig().public.logger

  const logger = createLogger({
    attributes: useAttributes(),
    transports: useTransports(),
    level: LogLevels.INFO,
  })

  if (config.wrapConsole) {
    logger.wrapConsole({
      logToNativeConsole: process.client,
    })
  }

  return {
    provide: {
      logger,
    },
  }
}

export default defineNuxtPlugin<Injections>(createLoggerPlugin)
